import React from "react";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as Common from "../functions/commonFunctions";
import * as GC from "../../../../common/common";

import $ from "jquery";
import { TelemetryHandlerOptions } from "@microsoft/microsoft-graph-client";

class AddWorkResourcesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      code: GC.CodeAutoFill("WB"),
      omschrijving: "",
      prijs: "",
      type: "",
      kosteneenheid: "",
      active: true,
      naamRequiredAlert: false,
      codeRequiredAlert: false,
      codeAlertText: "",
      omschrijvingRequiredAlert: false,
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("BS") });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
    if (value != "" && name == "code") {
      this.setState({ codeRequiredAlert: false });
    }
    if (value != "" && name == "omschrijving") {
      this.setState({ omschrijvingRequiredAlert: false });
    }
  }

  async handleSubmit() {
    $("#cover-spin").show(0);

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });
    this.state.omschrijving == ""
      ? await this.setState({ omschrijvingRequiredAlert: true })
      : await this.setState({ omschrijvingRequiredAlert: false });

    var model = {
      relationships: { definition: { code: "WERKBRON" } },
      content: {
        algemeen: {
          type: $("#werkbron-type").val(),
          actief: this.state.active,
          naam: this.state.naam,
          code: this.state.code,
          omschrijving: this.state.omschrijving,
          kosteneenheid: $("#werkbron-kosteneenheid").val(),
          prijs: this.state.prijs,
        },
      },
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      this.state.naamRequiredAlert !== true &&
      this.state.codeRequiredAlert !== true &&
      this.state.omschrijvingRequiredAlert !== true &&
      isUnique === true
    ) {
      omnimap
        .SaveOrEditAction(
          model,
          "POST",
          "",
          window.$catalog_management_units_token
        )
        .then((data) => {
          if (data.result.status === "OK") {
            CallBackFunctions.WerkbronSavedCallBack(
              window.$catalog_management_units_token
            );
          }
        });
      this.resetForm();
    } else {
      $("#cover-spin").hide(0);
    }
  }

  componentDidMount() {
    var that = this;
    $(document).on("click", "#werkbron_toevoegen", function () {
      $("#werkbron_toevoegen_modal").modal("show");
      Common.GetColumnProperties("create");
      that.resetForm();
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="werkbron_toevoegen_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe Werkbron</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Naam *
              </label>
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                id="werkbron-naam"
                type="input"
                className="form-control"
                placeholder="Naam"
                autocomplete="off"
                name="naam"
                value={this.state.naam}
                onChange={this.handleInputChange}
              />
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Code *
              </label>
              <label
                className={
                  this.state.codeRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} {this.state.codeAlertText}
              </label>
              <input
                id="werkbron-code"
                type="input"
                className="form-control"
                placeholder="Code"
                autocomplete="off"
                name="code"
                value={this.state.code}
                onChange={this.handleInputChange}
              />
              <label
                className={
                  this.state.omschrijvingRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Omschrijving *
              </label>
              <label
                className={
                  this.state.omschrijvingRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                id="werkbron-omschrijving"
                type="input"
                className="form-control"
                placeholder="Omschrijving"
                autocomplete="off"
                name="omschrijving"
                value={this.state.omschrijving}
                onChange={this.handleInputChange}
              />
              <label>Prijs</label>
              <input
                id="werkbron-prijs"
                type="input"
                className="form-control"
                placeholder="Prijs"
                autocomplete="off"
                name="prijs"
                value={this.state.prijs}
                onChange={this.handleInputChange}
              />
              <label>Type *</label>

              <select
                class="form-control"
                id="werkbron-type"
                name="type"
                value={this.state.type}
                onChange={this.handleInputChange}
              ></select>
              <label>Kosteneenheid *</label>

              <select
                class="form-control"
                id="werkbron-kosteneenheid"
                name="kosteneenheid"
                value={this.state.kosteneenheid}
                onChange={this.handleInputChange}
              ></select>
              <label>Actief</label>
              <label className="switch">
                <input
                  id="werkbron-actief"
                  type="checkbox"
                  name="active"
                  defaultChecked
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="save-werkbron"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddWorkResourcesModal;
